import { useContext } from "react";
import { LookupInfoContext } from "../../context";
export var useLookupInfoContext = function () { return useContext(LookupInfoContext); };
export var useLookupInfo = function (matchType, matchId) { var _a; return (_a = useLookupInfoContext()) === null || _a === void 0 ? void 0 : _a.getLookupInfo(matchType, matchId); };
export var useUpdateLookupInfo = function () { var _a; return (_a = useLookupInfoContext()) === null || _a === void 0 ? void 0 : _a.updateLookupInfo; };
//# sourceMappingURL=use-lookup-info.js.map